import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as CoreActions from '../actions/core.actions';
import {catchError, exhaustMap, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {AuthService} from '../../../auth/services/auth.service';
import {SessionService} from '../../services/session.service';

@Injectable()
export class CoreEffects {
  getUser = createEffect(() => {
    return this.actions$.pipe(
      ofType(CoreActions.getUser),
      /** An EMPTY observable only emits completion. Replace with your own observable API request */
      exhaustMap(action =>
        this.authService.getUser().pipe(
          map(user => CoreActions.getUserSuccess({user})),
          catchError(error => of(CoreActions.getUserError({error})))
        )
      )
    );
  });
  constructor(private actions$: Actions, private authService: AuthService) {}
}
